import React from 'react';
import IconButton from '@mui/material/IconButton';
import { X } from 'lucide-react';

import styles from 'src/components/inline-banner/InlineBanner.module.css';

export { styles as bannerStyles };

type Severity = 'error' | 'warning' | 'info' | 'success';

interface InlineBannerProps {
    severity: Severity;
    icon?: React.ReactNode;
    title: string;
    description: string;
    actions?: React.ReactNode;
    onDismiss?: () => void;
}

export default function InlineBanner({ severity, icon, title, description, actions, onDismiss }: InlineBannerProps) {
    return (
        <div className={styles.banner} data-severity={severity} role="alert">
            {icon && (
                <span className={styles.icon} data-severity={severity}>
                    {icon}
                </span>
            )}
            <span className={styles.body}>
                <span className={styles.title}>{title}</span>
                <span className={styles.description}>{description}</span>
            </span>
            {actions && <span className={styles.actions}>{actions}</span>}
            {onDismiss && (
                <IconButton
                    size="small"
                    className={styles.closeBtn}
                    onClick={onDismiss}
                    aria-label="Dismiss"
                >
                    <X size={16} />
                </IconButton>
            )}
        </div>
    );
}
